'use client';
import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const Checkbox = renderWithRef('Checkbox', null, (c, i)=>{
    let { instant: a = false, skin: p = 'standard', indeterminate: s = false } = c, u = _object_without_properties(c, [
        "instant",
        "skin",
        "indeterminate"
    ]), l = new Set([
        'swan-checkbox'
    ]);
    'favorite' == p && l.add('swan-checkbox-skin-favorite'), a && l.add('swan-checkbox-instant');
    let b = useRef(void 0), f = assignRefs(b, i);
    return useEffect(()=>{
        b.current && (b.current.indeterminate = !!s);
    }, [
        s
    ]), jsx(RenderComp, {
        root: "input",
        forwardedRef: f,
        classNames: l,
        props: _object_spread({
            type: 'checkbox'
        }, u),
        children: c.children
    });
});

export { Checkbox };
